<div class="content__empty">
  <span class="content__empty-icon"><i class="icon icon--compass"></i></span>
  <h2><%= _lcs( 'Diese Seite gibt es nicht' ) %></h2>
  <p><%= _lcs( 'Der Link ist veraltet oder unvollständig.' ) %></p>
  <button type="button" class="btn btn--primary btn--sm" data-id="home"><%= _lcs( 'Zur Übersicht' ) %></button>
</div>
